import Utils from '../../modules/utils'

const saveMessage = (message, callbackFunc) => {
  const url = 'grok'
  const data = {message}
  Utils.post(url, data, callbackFunc)
}

export {saveMessage}
